(() => {
  function init() {
    const shell = document.querySelector('[data-sg-header]');
    if (!shell || shell.dataset.scrollBound) return;
    if (shell.classList.contains('sg-header-home')) {
      const header = shell.closest('.section-header');
      if (!header) return;
      shell.dataset.scrollBound = 'true';
      let pending = false;
      const syncHome = () => {
        header.classList.toggle('sg-home-scrolled', window.scrollY > 80);
        pending = false;
      };
      const scheduleHome = () => {
        if (!pending) {
          pending = true;
          requestAnimationFrame(syncHome);
        }
      };
      syncHome();
      window.addEventListener('scroll', scheduleHome, {passive:true});
      window.addEventListener('pageshow', syncHome);
      return;
    }
    shell.dataset.scrollBound = 'true';
    const size = () => document.documentElement.style.setProperty('--sg-header-height', shell.offsetHeight + 'px');
    const sync = () => shell.classList.toggle('sg-header-overlay', shell.classList.contains('sg-header-home') && scrollY < 32);
    size(); sync();
    new ResizeObserver(size).observe(shell);
    window.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('pageshow', sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
